import { createElement, Fragment } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { RichText, useBlockProps } from '@wordpress/block-editor';
import { __, sprintf } from '@wordpress/i18n';
export default function save(_ref) {
  let {
    attributes
  } = _ref;
  const {
    href,
    fileId,
    fileName,
    textLinkHref,
    textLinkTarget,
    showDownloadButton,
    downloadButtonText,
    displayPreview,
    previewHeight
  } = attributes;
  const pdfEmbedLabel = RichText.isEmpty(fileName) ? __('PDF embed') : sprintf(
  /* translators: %s: filename. */
  __('Embed of %s.'), fileName);
  const hasFilename = !RichText.isEmpty(fileName); // Only output an `aria-describedby` when the element it's referring to is
  // actually rendered.

  const describedById = hasFilename ? fileId : undefined;
  return href && createElement("div", useBlockProps.save(), displayPreview && createElement(Fragment, null, createElement("object", {
    className: "wp-block-file__embed",
    data: href,
    type: "application/pdf",
    style: {
      width: '100%',
      height: `${previewHeight}px`
    },
    "aria-label": pdfEmbedLabel
  })), hasFilename && createElement("a", {
    id: describedById,
    href: textLinkHref,
    target: textLinkTarget,
    rel: textLinkTarget ? 'noreferrer noopener' : undefined
  }, createElement(RichText.Content, {
    value: fileName
  })), showDownloadButton && createElement("a", {
    href: href,
    className: "wp-block-file__button",
    download: true,
    "aria-describedby": describedById
  }, createElement(RichText.Content, {
    value: downloadButtonText
  })));
}
//# sourceMappingURL=save.js.map